import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Project, PageResponse, StepPermissions } from '../models/models';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  private readonly apiUrl = `${environment.apiUrl}/projects`;

  constructor(private http: HttpClient) { }

  getProjects(
    search: string = '',
    page: number = 0,
    size: number = 10,
    sort: string = 'name,asc',
    statusId?: number | null,
    showArchived: boolean = false
  ): Observable<PageResponse<Project>> {
    let params = new HttpParams()
      .set('search', search)
      .set('page', page.toString())
      .set('size', size.toString())
      .set('sort', sort)
      .set('showArchived', String(showArchived));
    if (statusId !== null && statusId !== undefined) {
      params = params.set('statusId', statusId.toString());
    }
    return this.http.get<PageResponse<Project>>(this.apiUrl, { params });
  }

  createProject(project: Project): Observable<Project> {
    return this.http.post<Project>(this.apiUrl, project);
  }

  getProjectById(id: number): Observable<Project> {
    return this.http.get<Project>(`${this.apiUrl}/${id}`);
  }

  updateProject(id: number, project: Project): Observable<Project> {
    return this.http.put<Project>(`${this.apiUrl}/${id}`, project);
  }

  getWorkflowPermissions(projectId: number): Observable<StepPermissions> {
    return this.http.get<StepPermissions>(`${this.apiUrl}/${projectId}/workflow/permissions`);
  }

  validateWorkflow(projectId: number): Observable<Project> {
    return this.http.post<Project>(`${this.apiUrl}/${projectId}/workflow/validate`, {});
  }

  rejectWorkflow(projectId: number): Observable<Project> {
    return this.http.post<Project>(`${this.apiUrl}/${projectId}/workflow/reject`, {});
  }

  resetWorkflow(projectId: number): Observable<Project> {
    return this.http.post<Project>(`${this.apiUrl}/${projectId}/workflow/reset`, {});
  }

  deleteProject(projectId: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${projectId}`);
  }

  archiveProject(projectId: number): Observable<Project> {
    // Convention d'API: endpoint d'archivage REST dédié
    return this.http.post<Project>(`${this.apiUrl}/${projectId}/archive`, {});
  }

  unarchiveProject(projectId: number): Observable<Project> {
    return this.http.post<Project>(`${this.apiUrl}/${projectId}/unarchive`, {});
  }
}
